/*
  Favoris INERCY.

  Stockage : un cookie, un an, contenant les identifiants produit
  separes par des virgules. Quand un client est connecte, la cle est
  suffixee par son identifiant : deux personnes sur le meme navigateur
  ne melangent pas leurs favoris, et la liste d'un visiteur anonyme
  n'est pas absorbee par le premier compte qui se connecte.

  Le rendu de la page favoris se fait cote client : la page contient
  toutes les fiches produit, masquees, et on revele celles de la liste.
*/
(function () {
  'use strict';

  var BASE_KEY = 'inercy_wishlist';
  var MAX_AGE = 60 * 60 * 24 * 365;

  function storageKey() {
    var scope = window.INERCY_WISHLIST_SCOPE;
    return scope ? BASE_KEY + '_' + scope : BASE_KEY;
  }

  function read() {
    var key = storageKey();
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + key + '=([^;]*)'));
    if (!match) return [];
    try {
      return decodeURIComponent(match[1]).split(',').filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function write(ids) {
    document.cookie =
      storageKey() +
      '=' +
      encodeURIComponent(ids.join(',')) +
      '; path=/; max-age=' +
      MAX_AGE +
      '; SameSite=Lax';
  }

  function has(id) {
    return read().indexOf(String(id)) !== -1;
  }

  function toggle(id) {
    id = String(id);
    var ids = read();
    var i = ids.indexOf(id);
    if (i === -1) {
      ids.push(id);
    } else {
      ids.splice(i, 1);
    }
    write(ids);
    return i === -1;
  }

  /* ---------- Affichage ---------- */

  function paintButton(btn) {
    var active = has(btn.getAttribute('data-product-id'));
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.classList.toggle('is-active', active);
  }

  function paintAllButtons(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-wishlist-toggle]').forEach(paintButton);
  }

  function paintCount() {
    var n = read().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = n ? '(' + n + ')' : '';
      el.hidden = n === 0;
    });
  }

  /* ---------- Page favoris ---------- */

  function paintWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    var ids = read();
    var shown = 0;

    page.querySelectorAll('[data-wishlist-item]').forEach(function (item) {
      var keep = ids.indexOf(item.getAttribute('data-product-id')) !== -1;
      item.hidden = !keep;
      if (keep) shown++;
    });

    var empty = page.querySelector('[data-wishlist-empty]');
    var grid = page.querySelector('[data-wishlist-grid]');
    if (empty) empty.hidden = shown > 0;
    if (grid) grid.hidden = shown === 0;
  }

  /* ---------- Evenements ---------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-wishlist-toggle]');
    if (!btn) return;

    // La carte entiere est un lien : sans ca, un clic sur le coeur
    // ouvrirait la fiche produit.
    event.preventDefault();
    event.stopPropagation();

    toggle(btn.getAttribute('data-product-id'));
    paintAllButtons();
    paintCount();
    paintWishlistPage();
  });

  function init() {
    paintAllButtons();
    paintCount();
    paintWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Les cartes chargees apres coup (slider, filtres de collection,
  // rendu de section) doivent recevoir leur etat.
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () {
    paintAllButtons();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.INERCY_WISHLIST = { read: read, has: has, toggle: toggle, refresh: init };
})();
